import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
    OnInit,
    OnChanges,
    SimpleChanges,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Subscription } from "rxjs";

import { GridSortByOption, Sort } from "@hermes/states/grid-filters-state";

/**
 * Sort by button component
 */
@Component({
    selector: "h-grid-sort",
    templateUrl: "./grid-sort.component.html",
    styleUrls: ["./grid-sort.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridSortComponent implements OnInit, OnChanges, OnDestroy {
    /* Selected option */
    @Input()
    public selectedValue: Sort;

    @Output()
    public sortChanged: EventEmitter<GridSortByOption> =
        new EventEmitter<GridSortByOption>();

    /* Displayed option text */
    public displayedText: string;

    public sortOptions: GridSortByOption[] = [
        {
            sort: Sort.relevance,
            label: $localize`:@@hermes-search-result.relevance:Relevance`,
        },
        {
            sort: Sort.priceasc,
            label: $localize`:@@hermes-search-result.price-low:Lowest price`,
        },
        {
            sort: Sort.pricedsc,
            label: $localize`:@@hermes-search-result.price-high:Highest price`,
        },
    ];

    public sortControl: FormControl = new FormControl(this.sortOptions[0]);

    private subscription = new Subscription();

    constructor(private cd: ChangeDetectorRef) {}

    public ngOnChanges(changes: SimpleChanges): void {
        if (
            changes.selectedValue.previousValue !==
            changes.selectedValue.currentValue
        ) {
            this.updateForm();
            this.cd.markForCheck();
        }
    }

    public ngOnInit(): void {
        this.updateForm();

        this.subscription.add(
            this.sortControl.valueChanges.subscribe(
                (value: GridSortByOption) => {
                    this.sortChanged.emit(value);
                    this.selectedValue = value.sort;
                    this.cd.markForCheck();
                },
            ),
        );
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    public trackBySortOption(
        index: number,
        sortOption: GridSortByOption,
    ): string {
        return `${index}_${sortOption?.label}`;
    }

    private updateForm(): void {
        this.sortOptions.forEach((gridSortOption: GridSortByOption) => {
            if (
                gridSortOption.sort === this.selectedValue &&
                this.sortControl.value !== gridSortOption
            ) {
                this.sortControl.setValue(gridSortOption);
            }
        });
    }
}
